import { useMutation } from '@tanstack/react-query'

import { changeReservationProducts } from '../request/reservationApis'

import type {
  IChangeReservationProductsRequest,
  IReservation,
} from '../../model'
import type { AxiosError } from 'axios'

interface IUseChangeReservationProductsMutationParams {
  onSuccess?: (reservation: IReservation) => void
  onError?: (error: AxiosError) => void
}

interface IMutationVariables {
  reservationId: number
  requestBody: IChangeReservationProductsRequest
}

const useChangeReservationProductsMutation = ({
  onSuccess,
  onError,
}: IUseChangeReservationProductsMutationParams) => {
  return useMutation({
    mutationFn: ({ reservationId, requestBody }: IMutationVariables) =>
      changeReservationProducts(reservationId, requestBody),
    onSuccess,
    onError,
    throwOnError: false,
  })
}

export default useChangeReservationProductsMutation
